import React from 'react'
import { Alert } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExport } from '@fortawesome/pro-duotone-svg-icons/faFileExport'
import DefaultSearchbar from '@/Components/Elements/Search/DefaultSearchbar'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'
import { KedocxTableProps } from '../types'

export default function KedocxTable(props: KedocxTableProps) {
    const {
        kedo,
        kedocx,
        selected,
        errorkedocx,
        fileType,
        onExport,
        searchValue,
        handleFilterChange,
        handleSearchKedocx,
        resetButtonKedocx,
        onChangeKedocx,
    } = props

    return (
        <div className="table-responsive">
            <br />
            <h5>{kedo.t('Select Kedocx')}</h5>
            <DefaultSearchbar
                kedo={kedo}
                searchName={searchValue}
                handleChange={handleFilterChange}
                handleSearch={handleSearchKedocx}
                resetButton={resetButtonKedocx}
            />

            <table className="table table-striped table-hover">
                <thead>
                    <tr>
                        <th style={{ width: '5%' }}>&nbsp;</th>
                        <th style={{ width: '5%' }}>#</th>
                        <th>{kedo.t('Name')}</th>
                    </tr>
                </thead>

                <tbody>
                    {kedocx && kedocx.length > 0 ? (
                        kedocx.map((item) => (
                            <tr key={item.id}>
                                <td>
                                    <input
                                        type="radio"
                                        value={item.id}
                                        checked={selected === item.id}
                                        onChange={(event) =>
                                            onChangeKedocx(event)
                                        }
                                    />
                                </td>
                                <td>{item.id}</td>
                                <td>{item.name}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={3}>
                                <Alert severity="warning">
                                    &nbsp; {kedo.t('No files found')}
                                </Alert>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {errorkedocx && (
                <div>
                    <Alert severity="error">{errorkedocx}</Alert>
                </div>
            )}

            <br />

            {fileType && (
                <StyledButton onClick={onExport} disabled={!selected}>
                    <FontAwesomeIcon icon={faFileExport} /> &nbsp;{' '}
                    {kedo.t('Export')}
                </StyledButton>
            )}
        </div>
    )
}
